var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLif3LogoShortSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3242 10.5523L3.12142 14H1.02148L5.7753 0.849121H6.99718H8.21906L12.9723 14H10.815L6.97748 2.68198L4.89664 8.81912L4.3242 10.5523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66121 12.2661H0V13.9999H1.66121V12.2661Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32287 1.38368C8.32287 2.14809 5.67139 2.14809 5.67139 1.38368C5.67139 1.0167 5.81106 0.664759 6.05969 0.405269C6.30832 0.14578 6.64552 0 6.99713 0C7.34874 0 7.68595 0.14578 7.93457 0.405269C8.1832 0.664759 8.32287 1.0167 8.32287 1.38368",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 12.2661H12.3389V13.9999H14.0001V12.2661Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLif3LogoShortSmall);
export default __webpack_public_path__ + "static/media/lif3-logo-short-small.3509819b07da3a6acab2571bc0f1e107.svg";
export { ForwardRef as ReactComponent };